import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ButtonStyleCheckbox } from '../../Inputs';
import { AddressVerifyCell } from './AddressVerifyCell.component';
import { AddressOptionType } from './AddressVerifyModal.component';

export type ConvertedAddressFormatType = {
  address1: string;
  address2: string;
  addressCityState: string;
};

export type AddressVerifySelectType = {
  verifyAddress: ConvertedAddressFormatType | null;
  suggestionAddress: ConvertedAddressFormatType | null;
  checked: AddressOptionType;
  onChange: (arg0: AddressOptionType) => void;
};

const useStyles = makeStyles()((theme) => ({
  subtitle: {
    marginBottom: theme.spacing(1),
    display: 'block'
  },
}));

const useControlStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    borderRadius: theme.spacing(1),
  }
}));

export const AddressVerifySelect: React.VFC<AddressVerifySelectType> = ({ verifyAddress, suggestionAddress, onChange, checked }) => {
  const { classes } = useStyles();
  const { classes: controlClasses } = useControlStyles();

  const checkboxChangeHandler = (_checked: boolean, value: string) => {
    onChange(value as AddressOptionType);
  };

  return (
    <>
      <Typography variant="subtitle2" className={classes.subtitle}>Original Address</Typography>
      <ButtonStyleCheckbox
        label={verifyAddress ? <AddressVerifyCell address={verifyAddress} /> : ''}
        value="original"
        checked={checked === 'original'}
        onChange={checkboxChangeHandler}
        color="primary"
        controlClasses={controlClasses}
        control="radio"
      />
      <Typography variant="subtitle2" className={classes.subtitle}>Suggested Address</Typography>
      <ButtonStyleCheckbox
        label={suggestionAddress && verifyAddress ? (
          <AddressVerifyCell
            address={suggestionAddress}
            compareToAddress={verifyAddress}
          />
        ) : ''}
        value="suggested"
        checked={checked === 'suggested'}
        onChange={checkboxChangeHandler}
        color="primary"
        controlClasses={controlClasses}
        control="radio"
      />
    </>
  );
};
